import { VehicleType } from './types';

export const VEHICLE_TYPE_COLORS = {
  'Maruti Suzuki Dzire': {
    primary: { bgcolor: '#3b82f6' },
    border: { borderColor: '#2563eb' },
    text: { color: '#ffffff' },
    light: { bgcolor: '#dbeafe' },
    lightBorder: { borderColor: '#93c5fd' },
    lightText: { color: '#1d4ed8' },
    row: { bgcolor: '#eff6ff' },
    tentative: { borderColor: '#60a5fa' },
    waiting: { bgcolor: '#dbeafe' },
    waitingBorder: { borderColor: '#bfdbfe' },
    reposition: { bgcolor: '#eff6ff' },
    repositionBorder: { borderColor: '#bfdbfe' },
    repositionText: { color: '#1d4ed8' },
    iconBg: { bgcolor: '#dbeafe' },
    icon: { color: '#2563eb' },
    busyHigh: { bgcolor: '#2563eb' },
    busyMedium: { bgcolor: '#60a5fa' },
    busyLow: { bgcolor: '#bfdbfe' }
  },
  'Toyota Rumion S': {
    primary: { bgcolor: '#22c55e' },
    border: { borderColor: '#16a34a' },
    text: { color: '#ffffff' },
    light: { bgcolor: '#dcfce7' },
    lightBorder: { borderColor: '#86efac' },
    lightText: { color: '#15803d' },
    row: { bgcolor: '#f0fdf4' },
    tentative: { borderColor: '#4ade80' },
    waiting: { bgcolor: '#dcfce7' },
    waitingBorder: { borderColor: '#bbf7d0' },
    reposition: { bgcolor: '#f0fdf4' },
    repositionBorder: { borderColor: '#bbf7d0' },
    repositionText: { color: '#15803d' },
    iconBg: { bgcolor: '#dcfce7' },
    icon: { color: '#16a34a' },
    busyHigh: { bgcolor: '#16a34a' },
    busyMedium: { bgcolor: '#4ade80' },
    busyLow: { bgcolor: '#bbf7d0' }
  },
  'Kia Carens Premium': {
    primary: { bgcolor: '#f97316' },
    border: { borderColor: '#ea580c' },
    text: { color: '#ffffff' },
    light: { bgcolor: '#ffedd5' },
    lightBorder: { borderColor: '#fdba74' },
    lightText: { color: '#c2410c' },
    row: { bgcolor: '#fff7ed' },
    tentative: { borderColor: '#fb923c' },
    waiting: { bgcolor: '#ffedd5' },
    waitingBorder: { borderColor: '#fed7aa' },
    reposition: { bgcolor: '#fff7ed' },
    repositionBorder: { borderColor: '#fed7aa' },
    repositionText: { color: '#c2410c' },
    iconBg: { bgcolor: '#ffedd5' },
    icon: { color: '#ea580c' },
    busyHigh: { bgcolor: '#ea580c' },
    busyMedium: { bgcolor: '#fb923c' },
    busyLow: { bgcolor: '#fed7aa' }
  },
  'Toyota Crysta GX 7 STR': {
    primary: { bgcolor: '#a855f7' },
    border: { borderColor: '#9333ea' },
    text: { color: '#ffffff' },
    light: { bgcolor: '#f3e8ff' },
    lightBorder: { borderColor: '#d8b4fe' },
    lightText: { color: '#7e22ce' },
    row: { bgcolor: '#faf5ff' },
    tentative: { borderColor: '#c084fc' },
    waiting: { bgcolor: '#f3e8ff' },
    waitingBorder: { borderColor: '#e9d5ff' },
    reposition: { bgcolor: '#faf5ff' },
    repositionBorder: { borderColor: '#e9d5ff' },
    repositionText: { color: '#7e22ce' },
    iconBg: { bgcolor: '#f3e8ff' },
    icon: { color: '#9333ea' },
    busyHigh: { bgcolor: '#9333ea' },
    busyMedium: { bgcolor: '#c084fc' },
    busyLow: { bgcolor: '#e9d5ff' }
  }
} as const;

export function getVehicleTypeColor(vehicleType: VehicleType) {
  return VEHICLE_TYPE_COLORS[vehicleType];
}